module.exports = __webpack_public_path__ + "img/rectangle.a5eed0b1.png";